import { Card, Grid, Icon } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import Footer from 'examples/Footer'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import moment from 'jalali-moment'
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import PatientListTable from './PatientListTable';
import { getCalendar, getReservedCounter } from '../../api/routes';
import Flickity from 'react-flickity-component';
import "flickity/css/flickity.css";
import Loading from "../../components/Loading";
import { toast } from "react-toastify";


export default function ReservedList() {
    const [searchParams] = useSearchParams();
    const [reservedTimesList, setReservedTimesList] = useState([])
    const [reservationDay, setReservationDay] = useState([])
    const [loading, setLoading] = useState(false);

    const m = moment();

    useEffect(() => {
        setLoading(true)
        getCalendar(m?.locale('fa')?.format('YYYYMMDD'), (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setReservationDay(data)
        })
        getReservedCounter(m?.locale('fa')?.format('YYYYMMDD'), (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else{
                setLoading(false)
                return setReservedTimesList(data)
            }
        })
    }, [])


    const reservedDays = reservedTimesList.map(item => item.reservationDate);


    return (
        <>
            <DashboardLayout>
                <MDBox pt={2} mb={6}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                    <MDTypography variant="h6" color="white">
                                        لیست بیماران
                                    </MDTypography>
                                    <DashboardNavbar />
                                </MDBox>
                                <MDBox py={1} px={3}>
                                    <Flickity style={{ width: '100%' }} options={{ prevNextButtons: true, groupCells: 1, pageDots: false, rightToLeft: true, initialIndex: 0, contain: true }}>
                                        {reservationDay.map((item, index) => <section key={index} style={{ minWidth: '43px', background: reservedDays.includes(parseInt(item.CDate.split('/').join(''))) ? 'rgba(62, 205, 219,0.1)' : '#fff', height: '49px', border: item.Holiday == 1 ? '1px solid #fa3668' : reservedDays.includes(parseInt(item.CDate.split('/').join(''))) ? '2px solid #3ecddb' : '1px solid #dee2e6', margin: '1rem 0.5rem', borderRadius: '5px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                                            <Link to={`/ReservedList?date=${item.CDate.split('/').join('')}`}>
                                                <p style={{ fontSize: '14px', fontWeight: 'bold', textAlign: 'center' }}>{item.CDay}</p>
                                                <p style={{ fontSize: '12px' }}>{item.NMonth}</p>
                                                {reservedDays.includes(parseInt(item.CDate.split('/').join(''))) && <div style={{ position: 'absolute', top: '-0.5rem', fontSize: '12px', left: '-0.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '15px', height: '15px', borderRadius: '50%', color: '#fff', background: '#3ecddb' }}>{reservedTimesList[reservedTimesList.findIndex(element => element.reservationDate === parseInt(item.CDate.split('/').join('')))].counter}</div>}
                                            </Link>
                                        </section>)}
                                    </Flickity>
                                </MDBox>
                                <section style={{ display: 'flex', justifyContent: 'space-between', padding: '0.5rem 2rem' }}>
                                    <Link to={`/ReservedList?date=${moment(searchParams.get('date'), 'jYYYYjMMjDD').locale('fa').subtract(1, 'd').format('jYYYYjMMjDD')}`}>
                                        <Icon fontSize="large" style={{ color: 'rgb(62, 205, 219)' }}>navigate_next</Icon>
                                    </Link>
                                    <p style={{ fontSize: '16px' }}>تاریخ رزرو : {`${String(searchParams.get('date')).slice(0, 4)}/${String(searchParams.get('date')).slice(4, 6)}/${String(searchParams.get('date')).slice(6)}`}</p>
                                    <Link to={`/ReservedList?date=${moment(searchParams.get('date'), 'jYYYYjMMjDD').locale('fa').add(1, 'd').format('jYYYYjMMjDD')}`}>
                                        <Icon fontSize="large" style={{ color: 'rgb(62, 205, 219)' }}>chevron_left</Icon>
                                    </Link>
                                </section>
                                <PatientListTable reservationDate={searchParams.get('date')} />

                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <Loading loading={loading}/>
                <Footer />
            </DashboardLayout>
        </>)
}
